/**
 * @generated SignedSource<<a91f025d61938e8208a0a2395c420b21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetWeatherCondition = "BROKEN_CLOUDS" | "CLEAR_SKY" | "FEW_CLOUDS" | "MIST" | "RAIN" | "SCATTERED_CLOUDS" | "SHOWER_RAIN" | "SNOW" | "THUNDERSTORM";
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherBackground_WidgetWeather$data = {
  readonly currentOccasion: {
    readonly condition: WidgetWeatherCondition;
  } | null;
  readonly " $fragmentType": "WidgetWeatherBackground_WidgetWeather";
};
export type WidgetWeatherBackground_WidgetWeather$key = {
  readonly " $data"?: WidgetWeatherBackground_WidgetWeather$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherBackground_WidgetWeather">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeatherBackground_WidgetWeather",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetWeatherOccasion",
      "kind": "LinkedField",
      "name": "currentOccasion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "condition",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetWeather",
  "abstractKey": null
};

(node as any).hash = "091c2d5f27c9ef448abe847488a709a9";

export default node;
